import React, { PropTypes } from 'react';

import { apiErrorPropType, eventFullPropType } from '../../proptypes';

import Container from '../Container';
import EventDetailPageMeta from '../EventDetailPage/components/EventDetailPageMeta';
import EventTickets from './components/EventTickets';
import LoadingEllipsis from '../LoadingEllipsis';
import HelpPrompt from '../HelpPrompt';

import { container } from './styles.module.css';

const EventTicketsPage = ({ fetching, error, event }) => {
  if (event) {
    return (
      <div>
        <EventDetailPageMeta
          {...event}
          meta={{ title: `Tickets — ${event.title}`, useTitleTemplate: true, canonical: undefined, robots: 'noindex' }}
        />
        <EventTickets event={event} />
        <HelpPrompt />
      </div>
    );
  }
  if (fetching) {
    return (
      <Container className={container}>
        <LoadingEllipsis htmlTag="h1" />
      </Container>
    );
  }
  return (
    <Container className={container}>
      <h1>{error && error.status === 404 ? 'Event not found' : 'Something went wrong'}</h1>
    </Container>
  );
};

EventTicketsPage.propTypes = {
  fetching: PropTypes.bool,
  error: apiErrorPropType,
  event: eventFullPropType,
};

EventTicketsPage.defaultProps = {
  fetching: false,
  error: null,
  event: null,
};

export default EventTicketsPage;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/component.jsx